export default __webpack_public_path__ + "static/media/email.54d57f36.png";